// creates an array of N - 1 ordered numbers (0 excluded, N included)
const createOrderedNumberList = n => [...Array(n + 1).keys()].splice(1, n + 1);
const defaultOptions = createOrderedNumberList(5).map(number => ({ value: number, text: number }));

export default {
  name: 'GcDropDown',
  data() {
    return {
      className: 'gc__dropdown',
    };
  },
  computed: {
    labelClassName() {
      return `${this.className}__label`;
    },
    requiredClassName() {
      return this.required ? `${this.className}__required` : '';
    },
    disabledClassName() {
      return this.disabled ? `${this.className}__disabled` : '';
    },
    hideLabelClassName() {
      return this.hideLabel ? `${this.className}--hidden` : '';
    },
  },
  props: {
    options: {
      type: Array,
      default() {
        return defaultOptions;
      },
    },
    selectId: {
      type: String,
      default: 'dropdown',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
